import { useTenant } from '../config/tenantConfig';
import TenantBrand from './TenantBrand';

const TenantHeaderMinimal = () => {
  const tenant = useTenant();

  if (tenant.id === 'default' && !tenant.logo) {
    return null;
  }

  return (
    <div
      className="absolute z-10"
      style={{
        top: 'max(0.5rem, env(safe-area-inset-top, 0px))',
        right: 'max(0.5rem, env(safe-area-inset-right, 0px))',
      }}
    >
      {/* Sem backdrop-blur: no iOS 18 Safari/PWA a logo some ou vira quadro branco */}
      <div className="flex items-center rounded-xl md:rounded-2xl px-3 py-2 md:px-4 md:py-2.5 bg-[#1a1625]/90 shadow-lg shadow-black/30">
        <TenantBrand
          tenant={tenant}
          imageClassName="h-8 md:h-14 w-auto max-w-[140px] md:max-w-[200px] object-contain"
          textClassName="font-serif text-wine-gold text-sm md:text-lg font-semibold tracking-wide whitespace-nowrap"
        />
      </div>
    </div>
  );
};

export default TenantHeaderMinimal;
